module.exports = __webpack_public_path__ + "img/fortune.1f113001.png";